import Big from 'big.js';
import { toNonExponential } from './format';
import { getPrecision } from '../func/helper';
import { SymbolsBySpot, Symbols } from '../types/trade';

const mapSymbols = (list: Symbols[]) => {
  const data = list.map((item) => {
    const contract_value_multiplier = item.contract_value_multiplier || '1';
    return {
      tick_size: toNonExponential(Number(item.tick_size)), //最小跳价
      price_precision: item.price_precision, //价格精度
      price_digit: getPrecision(item.price_precision), //精度位数
      contract_value: toNonExponential(Number(item.contract_value)), //合约面值
      contract_digit: getPrecision(new Big(item.contract_value).times(contract_value_multiplier).toString()), //合约面值位数
      logo: item.logo, //logo
      symbol: item.symbol, //交易对
      quote_currency: item.quote_currency,
      base_currency: item.base_currency,
      max_limit_order_quantity: item.max_limit_order_quantity,
      max_market_order_quantity: item.max_market_order_quantity,
      depth_step: Number(toNonExponential(Number(item.depth_step))),
      tag_ids: item.tag_ids,
      reduce_only_time: item.reduce_only_time || 0,
      delisting_time: item.delisting_time || 0,
      contract_value_multiplier: contract_value_multiplier,
      contract_value_multiplier_digit: getPrecision(contract_value_multiplier),
      trading_end_time: item.trading_end_time,
      trading_start_time: item.trading_start_time,
      sort: item.sort,
    };
  });

  return data;
};

const mapSymbolsBySpot = (list: SymbolsBySpot[]) => {
  const data = list.map((item) => {
    return {
      base_currency: item.base_currency,
      base_currency_precision: item.base_currency_precision,
      base_currency_digit: getPrecision(item.base_currency_precision),
      depth_step: toNonExponential(Number(item.depth_step)),
      logo: item.logo, //logo
      max_limit_order_quantity: item.max_limit_order_quantity,
      max_market_order_quantity: item.max_market_order_quantity,
      min_order_quantity: item.min_order_quantity,
      price_precision: item.price_precision, //价格精度
      quote_currency: item.quote_currency,
      sort: item.sort,
      tag_ids: item.tag_ids,
      price_digit: getPrecision(item.price_precision), //精度位数
      symbol: item.symbol, //交易对
      tick_size: toNonExponential(Number(item.tick_size)), //最小跳价
      trading_end_time: item.trading_end_time,
      trading_start_time: item.trading_start_time,
    };
  });

  return data;
};

export { mapSymbols, mapSymbolsBySpot };
